function removeSymbol (sourceData:any, symbol:string = '@') {
    Object.keys(sourceData).filter((key:any) => {
        if(key.indexOf(symbol) !== -1){
            delete sourceData[key];
        }
    })
}

function cleanData (source: any) {
    const fullData = {
        data: source['hydra:member'],
        links: source['hydra:totalItems']
    }

    removeSymbol(source);

    if(fullData.data){
        Object.values(fullData.data).filter((attr:any) => {
            removeSymbol(attr);
        })
    }
        
    return fullData;
}

const extractData = (source:any) => {
    return extractFullData(source).data;
};

const extractLinks = (source:any) => {
    return extractFullData(source).links;
};

const extractFullData = (source:any) => {
    const {links, data} = cleanData(source);
    return {
        data,
        meta: source.meta,
        links
    };
};

export { extractData, extractLinks, extractFullData, removeSymbol};
